import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import axios from 'axios'
import Toasted from 'vue-toasted'
import Vuelidate from 'vuelidate'
import VJstree from 'vue-jstree'
import { Simplert } from 'vue2-simplert-plugin'
import 'vue2-simplert-plugin/dist/vue2-simplert-plugin.min.css'


import 'bootstrap/dist/css/bootstrap.min.css'
import "./styles/custom.less";

axios.defaults.baseURL = process.env.VUE_APP_URL;

axios.defaults.headers.get['accept'] = 'application/json'

const token = localStorage.getItem('user-token')
console.log('main: token: ', token)
console.log('main: axios.defaults: ', axios.defaults)
console.log('main: axios.defaults.headers: ', axios.defaults.headers)

if (token) {
  axios.defaults.headers.common['api-token'] = token;
//   axios.defaults.headers.common['Access-Control-Allow-Origin'] =  "*"
//   axios.defaults.headers.common['Access-Control-Allow-Methods'] =  "GET,PUT,POST,DELETE,PATCH,OPTIONS"
}


axios.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },error => {
      switch (error.response.status) {
        case 401:
            localStorage.removeItem('token')
            location.reload();
          break;
      }
      switch (error.response.status) {
        case 422:
          // alert(error.response.data.messages[0])
          // this.$router.go(this.$router.currentRoute)
          break;
      }
      return Promise.reject(error.response);

  })

Vue.config.productionTip = false;

Vue.use(Toasted, { singleton: true, position:'top-center', theme: 'outline' })
Vue.use(Vuelidate)
Vue.use(VJstree)
Vue.use(Simplert)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
